import React from 'react'

import { pxToRem } from '@/shared/styles/themes'
import { styled } from '@mui/material'

export type FooterBottomProps = object

export const FooterBottom: React.FC<FooterBottomProps> = () => (
  <FooterContainer aria-hidden="true" />
)

const FooterContainer = styled('div')(({ theme }) => ({
  display: 'none',

  [theme.breakpoints.up('md')]: {
    display: 'block',
    backgroundImage: 'url(/images/web-footer-background.webp)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top',
    minHeight: pxToRem(150),
    width: '100%',
  },
}))
